import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    standalone: false,
  selector: 'integration-aws-cloudtrail',
  templateUrl: './integration-aws-cloudtrail.component.html',
  styleUrls: ['./integration-aws-cloudtrail.component.css'],
})
export class IntegrationAwsCloudTrailComponent implements OnInit {
  @Input() settingsForm: FormGroup;
  @Input() settings: any;

  public fields = [
    {'id': 'accessKey', 'name': 'Access Key', type: 'password'},
    {'id': 'secretKey', 'name': 'Secret Key', type: 'password'},
    {'id': 'region', 'name': 'Region'},
  ];

  public filterFields = [
    {'id': 'accessKeyId', 'name': 'AccessKeyId'},
    {'id': 'eventId', 'name': 'Event Id'},
    {'id': 'eventName', 'name': 'Event Name'},
    {'id': 'eventSource', 'name': 'Event Source'},
    {'id': 'readOnly', 'name': 'Read Only'},
    {'id': 'resourceName', 'name': 'Resource Name'},
    {'id': 'resourceType', 'name': 'Resource Type'},
    {'id': 'username', 'name': 'Username'},
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    for(var field of [...this.fields, ...this.filterFields]) {
      this.settingsForm.addControl(
        field.id,
        this.fb.control('', Validators.required)
      );
    }

    this.settingsForm.patchValue(this.settings);
  }
}
